export default __webpack_public_path__ + "media/images/features/jtb/map-7821319d432dd070a894b7666da4615b.png";